<template>
  <v-hover>
    <v-edit-dialog
      slot-scope="{ hover }"
      lazy
      large
      save-text="Сохранить"
      cancel-text="Отмена"
      hide-details
      width="auto"
      persistent
      @save="change"
      @cancel="closeDialog"
    >
      <div>
        {{ editableValue }}
      </div>
      <div
        v-if="hover"
        class="icon-reveal"
      >
        <v-icon
          class="pb-3 pl-2"
          color="blue darken-2"
          size="13px"
        >
          edit
        </v-icon>
      </div>
      <template v-slot:input>
        <v-text-field
          v-model="editableValue"
          :label="label.text"
          autofocus
          outline
          hide-details
          :height="44"
          class="mt-2"
        />
      </template>
    </v-edit-dialog>
  </v-hover>
</template>
<script>
export default {
  props: ["id", "value", "label"],
  data() {
    return {
      editableValue: "",
    };
  },
  created() {
    this.editableValue = this.value;
  },
  methods: {
    closeDialog() {
      this.editableValue = this.value;
    },
    change() {
      this.$emit("change", {
        id: this.id,
        newValue: this.editableValue,
        label: this.label.name,
      });
    },
  },
};
</script>
